import React from 'react';
import styled from 'styled-components';
import Radio from './index';

const isChecked = (currentValue, value) => {
  if (Array.isArray(currentValue)) {
    return currentValue.includes(value);
  }
  return currentValue === value;
};

export const Label = styled.label`
  display: flex;
  align-items: center;
  cursor: pointer;
  margin-bottom: .4rem;

  ${Radio} {
    flex-shrink: 0;
  }
`;

const MultiRadio = ({
  className,
  name,
  options,
  value,
  onChange,
  required = false,
}) => (
  <div className={className}>
    {options.map(({ label, value: v }) => (
      // eslint-disable-next-line jsx-a11y/label-has-associated-control
      <Label key={v}>
        <Radio
          checked={isChecked(value, v)}
          value={v}
          onChange={onChange}
          Tag="span"
          required={required}
          name={name}
        />
        {label || value}
      </Label>
    ))}
  </div>
);

export default styled(MultiRadio)``;
